import script from "./Workplace.vue?vue&type=script&setup=true&lang=js"
export * from "./Workplace.vue?vue&type=script&setup=true&lang=js"

import "./Workplace.vue?vue&type=style&index=0&id=d69a21f6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d69a21f6"]])

export default __exports__